import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {GridSummary} from 'constants/SampleConstants';
import StorableSearchInput from 'samples/storables/StorableSearchInput';
import {Title} from 'ui-library/Headers';

interface Props {
  onUpdate: (paneState: Partial<ExistingPlatePaneState>) => void;
  registryId: string;
  selectedGrid?: GridSummary | null;
}

export interface ExistingPlatePaneState {
  selectedGrid: GridSummary | null;
}

export interface ExistingPlatePaneWithSetterState extends ExistingPlatePaneState {
  setSelectedGrid: (grid: GridSummary | null) => void;
}

class ExistingPlatePane extends React.Component<Props> {
  _handlePlateChange = (plates: Array<GridSummary>): void => {
    const selectedGrid = plates.length ? plates[0] : null;
    this.props.onUpdate({selectedGrid});
  };

  render(): JSX.Element {
    return (
      <div>
        <Title>Search for plate</Title>
        <StorableSearchInput
          onChange={this._handlePlateChange}
          registryId={this.props.registryId}
          selectedStorables={this.props.selectedGrid ? [this.props.selectedGrid] : []}
          shouldAllowMultiple={false}
          storableTypes={[ModelTypeConstants.PLATE]}
        />
      </div>
    );
  }
}

export default ExistingPlatePane;
